module.exports = __webpack_public_path__ + "static/media/danny.bc3d169a.png";